module.exports = ".teste{\r\n    margin-left: 45px;\r\n    margin-right: 45px;\r\n}\r\n"